<template>
  <transition name="short-fade">
    <div v-if="loading" class="fullscreen-loader">
      <transition name="short-fade">
        <div v-if="debouncedLoading">
          <Loader />
        </div>
      </transition>
    </div>
  </transition>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';
import _debounce from 'lodash/debounce';

import Loader from '@/components/common/Loader.vue';
import { watchWhileActive } from '@/utils/vue-lifecycle';

export default defineComponent({
  components: {
    Loader,
  },
  props: {
    loading: {
      type: Boolean,
    },
    debounced: {
      type: Boolean,
    },
  },
  setup(props) {
    const debouncedLoading = ref(false);

    onMounted(debouncedLoad);

    function debouncedLoad() {
      if (props.debounced) {
        _debounce(() => (debouncedLoading.value = true), 500)();
      } else {
        debouncedLoading.value = true;
      }
    }

    watchWhileActive(
      () => props.loading,
      loading => {
        if (loading) {
          debouncedLoad();
        } else {
          debouncedLoading.value = false;
        }
      },
    );

    return {
      debouncedLoading,
    };
  },
});
</script>

<style lang="scss" scoped>
.fullscreen-loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: $black;
  z-index: $z-index-page-transition-curtain;
}
</style>
